/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Attaches an existing legal entity as a subsidiary. Name and SIRET are taken from the legal entity.
 * @export
 * @interface AttachSubsidiaryCommandDto
 */
export interface AttachSubsidiaryCommandDto {
    /**
     * Existing legal entity to attach
     * @type {string}
     * @memberof AttachSubsidiaryCommandDto
     */
    legalPersonId: string;
    /**
     * Revenue of the last closed fiscal year, in euros
     * @type {number}
     * @memberof AttachSubsidiaryCommandDto
     */
    revenue: number;
    /**
     * Number of employees
     * @type {number}
     * @memberof AttachSubsidiaryCommandDto
     */
    employeesCount: number;
    /**
     * Date calendaire "yyyy-MM-dd". L\'heure est ignorée par le back, aucune conversion de fuseau n\'est appliquée.
     * @type {string}
     * @memberof AttachSubsidiaryCommandDto
     */
    fiscalYearEnd: string;
}

/**
 * Check if a given object implements the AttachSubsidiaryCommandDto interface.
 */
export function instanceOfAttachSubsidiaryCommandDto(value: object): value is AttachSubsidiaryCommandDto {
    if (!('legalPersonId' in value) || value['legalPersonId'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('employeesCount' in value) || value['employeesCount'] === undefined) return false;
    if (!('fiscalYearEnd' in value) || value['fiscalYearEnd'] === undefined) return false;
    return true;
}

export function AttachSubsidiaryCommandDtoFromJSON(json: any): AttachSubsidiaryCommandDto {
    return AttachSubsidiaryCommandDtoFromJSONTyped(json, false);
}

export function AttachSubsidiaryCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachSubsidiaryCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'legalPersonId': json['legalPersonId'],
        'revenue': json['revenue'],
        'employeesCount': json['employeesCount'],
        'fiscalYearEnd': json['fiscalYearEnd'],
    };
}

export function AttachSubsidiaryCommandDtoToJSON(json: any): AttachSubsidiaryCommandDto {
    return AttachSubsidiaryCommandDtoToJSONTyped(json, false);
}

export function AttachSubsidiaryCommandDtoToJSONTyped(value?: AttachSubsidiaryCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'legalPersonId': value['legalPersonId'],
        'revenue': value['revenue'],
        'employeesCount': value['employeesCount'],
        'fiscalYearEnd': value['fiscalYearEnd'],
    };
}

